import type { ZodType } from "zod";
import { z } from "zod";

const SAFE_ID_REGEXP = /^[A-Za-z0-9_-]+$/u;

export interface ZodSafeId extends ZodType<string, string> {
  readonly startsWith: <T extends string>(
    prefix: T,
  ) => ZodType<`${T}${string}`, `${T}${string}`>;
}

export function safeId(): ZodSafeId {
  // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
  return z
    .string()
    .regex(SAFE_ID_REGEXP, "Must be a safe ID") as unknown as ZodSafeId;
}
